import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography, Button, Space, Table, Tag, Modal, Form, Input, Divider, message, Tooltip, Tabs } from 'antd';
import { EditOutlined, BankOutlined, DollarOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const IncomeAccount = () => {
  const navigate = useNavigate();

  const withdrawRate = 7.15;

  const [bankVisible, setBankVisible] = useState(false);
  const [bankForm] = Form.useForm();

  const [bankInfo] = useState({
    accountName: '东莞康林物联网有限公司',
    bankName: '中国建设银行股份有限公司东莞长安支行',
    bankCode: '105602001052',
    accountNo: '4420 1562 3000 5271 8888',
  });

  const balance = 71460.50;

  const billData = [
    { key: '1', billNo: 'BILL202603-002', billPeriod: '2026-02', apps: ['HomeStar (iOS-国内)', 'HomeStar (Android-国内)', 'HomeStar (iOS-海外)'], orderCount: 89, orderTotalCNY: 15820.00, orderTotalUSD: 2450.00, commissionTotalCNY: 1884.16, commissionTotalUSD: 280.67, settlementCNY: 10676.92, settlementUSD: 1583.78, usdRate: 7.10, confirmTime: '2026-03-11 10:00:00' },
    { key: '2', billNo: 'BILL202603-004', billPeriod: '2026-02', apps: ['HM IoT App (iOS-国内)', 'HM IoT App (Android-国内)'], orderCount: 45, orderTotalCNY: 6750.00, orderTotalUSD: 980.00, commissionTotalCNY: 810.00, commissionTotalUSD: 117.60, settlementCNY: 5359.50, settlementUSD: 745.78, usdRate: 7.15, confirmTime: '2026-03-08 14:00:00' },
    { key: '3', billNo: 'BILL202604-001', billPeriod: '2026-03', apps: ['HomeStar (iOS-国内)', 'HomeStar (Android-国内)', 'HomeStar (iOS-海外)', '牵心Pro (iOS-全球)', '牵心Pro (Android-全球)'], orderCount: 112, orderTotalCNY: 19800.00, orderTotalUSD: 3100.00, commissionTotalCNY: 2376.00, commissionTotalUSD: 372.00, settlementCNY: 13464.00, settlementUSD: 2108.00, usdRate: 7.15, confirmTime: '2026-04-06 10:30:00' },
  ];

  // TODO: 联调时替换为接口数据 — 广告收益账单（平台广告源结算入账）
  const adBillData = [
    { key: 'a1', billNo: 'ADBILL202608-002', billPeriod: '2026-08', appInfo: 'ParkingCloud (iOS-海外)', adPlatform: 'fengchuan', revenueCNY: 0, revenueUSD: 20000.00, commissionCNY: 3500.00, commissionUSD: 500.00, settlementCNY: 0, settlementUSD: 24000.00, settleCNYCny: 0, revenueTotalCNY: 0, usdRate: 7.15, confirmTime: '2026-09-06 10:30:00' },
    { key: 'a2', billNo: 'ADBILL202608-002', billPeriod: '2026-08', appInfo: 'ParkingCloud (Android-全球)', adPlatform: 'AdMob', revenueCNY: 0, revenueUSD: 12000.00, commissionCNY: 2100.00, commissionUSD: 300.00, settlementCNY: 0, settlementUSD: 8500.00, settleCNYCny: 0, revenueTotalCNY: 0, usdRate: 7.15, confirmTime: '2026-09-06 10:30:00' },
    { key: 'a3', billNo: 'ADBILL202609-001', billPeriod: '2026-09', appInfo: 'HM IoT App (iOS-海外)', adPlatform: 'max', revenueCNY: 8600.00, revenueUSD: 0, commissionCNY: 0, commissionUSD: 0, settlementCNY: 8600.00, settlementUSD: 0, settleCNYCny: 8600.00, revenueTotalCNY: 8600.00, usdRate: 7.15, confirmTime: '2026-10-06 10:00:00' },
  ];

  const adColumns = [
    { title: '账单编号', dataIndex: 'billNo', width: 170, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '账单周期', dataIndex: 'billPeriod', width: 90, render: (t) => <Tag>{t}</Tag> },
    { title: '出账应用', dataIndex: 'appInfo', width: 200, render: (t) => <span style={{ fontSize: 12 }}>{t}</span> },
    { title: '广告平台', dataIndex: 'adPlatform', width: 110, render: (t) => <Tag color="geekblue" style={{ border: 'none' }}>{t}</Tag> },
    { title: '广告收益', key: 'revenue', width: 140, align: 'right', render: (_, r) => (<div><div>¥ {r.revenueCNY.toFixed(2)}</div><div style={{ color: '#999', fontSize: 12 }}>$ {r.revenueUSD.toFixed(2)}</div></div>) },
    { title: '平台抽佣', key: 'commission', width: 150, align: 'right', render: (_, r) => (<div><div><Text type="danger">¥ {r.commissionCNY.toFixed(2)}</Text></div><div><Text type="danger" style={{ fontSize: 12 }}>$ {r.commissionUSD.toFixed(2)}</Text></div></div>) },
    { title: '结算金额(CNY)', dataIndex: 'settlementCNY', width: 130, align: 'right', render: (v) => <Text strong style={{ color: '#52c41a' }}>¥ {v.toFixed(2)}</Text> },
    { title: '结算金额(USD)', key: 'settlementUSD', width: 150, align: 'right', render: (_, r) => (<div><div><Text strong style={{ color: '#52c41a' }}>$ {r.settlementUSD.toFixed(2)}</Text></div><div><Text type="secondary" style={{ fontSize: 11 }}>× {r.usdRate.toFixed(4)}</Text></div></div>) },
    { title: '收益总额(CNY)', key: 'totalCNY', width: 130, align: 'right', render: (_, r) => <Text strong style={{ color: '#fa8c16', fontSize: 14 }}>¥ {(r.settlementCNY + r.settlementUSD * r.usdRate).toFixed(2)}</Text> },
    { title: '确认出账时间', dataIndex: 'confirmTime', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
  ];

  const columns = [
    { title: '账单编号', dataIndex: 'billNo', width: 160, render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
    { title: '账单周期', dataIndex: 'billPeriod', width: 90, render: (t) => <Tag>{t}</Tag> },
    { title: '出账应用', key: 'apps', width: 160, render: (_, r) => {
      const apps = r.apps || [];
      if (apps.length <= 2) return <div>{apps.map((a, i) => <div key={i} style={{ fontSize: 12 }}>{a}</div>)}</div>;
      return <Tooltip title={apps.join('、')}><div><div style={{ fontSize: 12 }}>{apps[0]}</div><div style={{ fontSize: 12 }}>{apps[1]}</div><Text type="secondary" style={{ fontSize: 11 }}>等 {apps.length} 个端...</Text></div></Tooltip>;
    }},
    { title: '订单笔数', dataIndex: 'orderCount', width: 80, align: 'right', render: (v) => `${v} 笔` },
    { title: '订单总金额', key: 'orderTotal', width: 140, align: 'right', render: (_, r) => (<div><div>¥ {r.orderTotalCNY.toFixed(2)}</div><div>$ {r.orderTotalUSD.toFixed(2)}</div></div>) },
    { title: '平台抽佣', key: 'commission', width: 150, align: 'right', render: (_, r) => {
      const rateCNY = r.orderTotalCNY ? (r.commissionTotalCNY / r.orderTotalCNY * 100).toFixed(1) : 0;
      return (<div><div><Text type="secondary" style={{ fontSize: 12 }}>比例 {rateCNY}%</Text></div><div><Text type="danger">¥ {r.commissionTotalCNY.toFixed(2)}</Text></div><div><Text type="danger">$ {r.commissionTotalUSD.toFixed(2)}</Text></div></div>);
    }},
    { title: '结算金额(CNY)', dataIndex: 'settlementCNY', width: 130, align: 'right', render: (v) => <Text strong style={{ color: '#52c41a' }}>¥ {v.toFixed(2)}</Text> },
    { title: '结算金额(USD)', key: 'settlementUSD', width: 160, align: 'right', render: (_, r) => (<div><div><Text strong style={{ color: '#52c41a' }}>$ {r.settlementUSD.toFixed(2)}</Text></div><div><Text type="secondary" style={{ fontSize: 11 }}>× {r.usdRate.toFixed(4)}</Text></div><div><Text style={{ color: '#52c41a', fontSize: 12 }}>= ¥ {(r.settlementUSD * r.usdRate).toFixed(2)}</Text></div></div>) },
    { title: '收益总额(CNY)', key: 'totalCNY', width: 130, align: 'right', render: (_, r) => <Text strong style={{ color: '#fa8c16', fontSize: 14 }}>¥ {(r.settlementCNY + r.settlementUSD * r.usdRate).toFixed(2)}</Text> },
    { title: '确认出账时间', dataIndex: 'confirmTime', width: 170, render: (t) => <Text type="secondary">{t}</Text> },
  ];

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 16 }}><Title level={4}>收益账户</Title></div>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        {/* 左：账户余额 */}
        <Col span={12}>
          <Card bordered={false} style={{ borderRadius: 12, height: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <Text type="secondary" style={{ fontSize: 13 }}>人民币余额</Text>
                <div style={{ marginTop: 8 }}>
                  <Text style={{ fontSize: 32, fontWeight: 600, color: 'rgba(0,0,0,0.85)' }}>¥ {balance.toFixed(2)}</Text>
                </div>
                <div style={{ marginTop: 4 }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    来源：平台代收款订单结算
                    <Tooltip title="平台代收款的已确认抽佣账单，扣除底价、手续费、抽佣后的结算金额，其中美元部分按出账结算汇率折算为人民币"><InfoCircleOutlined style={{ marginLeft: 4, color: '#8c8c8c' }} /></Tooltip>
                  </Text>
                </div>
                <Divider style={{ margin: '12px 0' }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>最新结算汇率：1 USD = {withdrawRate.toFixed(4)} CNY</Text>
                </div>
              </div>
              <Button type="primary" icon={<DollarOutlined />} onClick={() => navigate('/cost/income/withdraw')}>收益提现</Button>
            </div>
          </Card>
        </Col>

        {/* 右：提现账户 */}
        <Col span={12}>
          <Card bordered={false} style={{ borderRadius: 12, height: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
            title={<Space><BankOutlined /><span>提现账户</span></Space>}
            extra={<Button type="link" size="small" icon={<EditOutlined />} onClick={() => { bankForm.setFieldsValue(bankInfo); setBankVisible(true); }}>修改</Button>}
          >
            <Row gutter={[24, 8]}>
              <Col span={12}><Text type="secondary" style={{ fontSize: 12 }}>账户名</Text><div style={{ fontWeight: 500 }}>{bankInfo.accountName}</div></Col>
              <Col span={12}><Text type="secondary" style={{ fontSize: 12 }}>开户银行</Text><div style={{ fontWeight: 500 }}>{bankInfo.bankName}</div></Col>
              <Col span={12}><Text type="secondary" style={{ fontSize: 12 }}>开户行号</Text><div style={{ fontFamily: 'monospace' }}>{bankInfo.bankCode}</div></Col>
              <Col span={12}><Text type="secondary" style={{ fontSize: 12 }}>银行账号</Text><div style={{ fontFamily: 'monospace' }}>{bankInfo.accountNo}</div></Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {/* 账单列表 */}
      <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}
        title={<Space><DollarOutlined /><span>收益账单</span></Space>}
      >
        <Tabs
          defaultActiveKey="value"
          items={[
            {
              key: 'value',
              label: '增值收益',
              children: (
        <Table columns={columns} dataSource={billData} rowKey="key"
          pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
          summary={(pageData) => {
            const pageCNY = pageData.reduce((s, r) => s + r.settlementCNY, 0);
            const pageUSD = pageData.reduce((s, r) => s + r.settlementUSD, 0);
            const pageUsdCny = pageData.reduce((s, r) => s + r.settlementUSD * r.usdRate, 0);
            const pageTotal = pageData.reduce((s, r) => s + r.settlementCNY + r.settlementUSD * r.usdRate, 0);
            const totalCNY = billData.reduce((s, r) => s + r.settlementCNY, 0);
            const totalUSD = billData.reduce((s, r) => s + r.settlementUSD, 0);
            const totalUsdCny = billData.reduce((s, r) => s + r.settlementUSD * r.usdRate, 0);
            const grandTotal = billData.reduce((s, r) => s + r.settlementCNY + r.settlementUSD * r.usdRate, 0);
            return (
              <>
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={6}><Text type="secondary">本页小计</Text></Table.Summary.Cell>
                  <Table.Summary.Cell align="right"><Text style={{ color: '#52c41a' }}>¥ {pageCNY.toFixed(2)}</Text></Table.Summary.Cell>
                  <Table.Summary.Cell align="right"><div><Text style={{ color: '#52c41a' }}>$ {pageUSD.toFixed(2)}</Text></div><div><Text style={{ color: '#52c41a', fontSize: 12 }}>¥ {pageUsdCny.toFixed(2)}</Text></div></Table.Summary.Cell>
                  <Table.Summary.Cell align="right"><Text style={{ color: '#fa8c16' }}>¥ {pageTotal.toFixed(2)}</Text></Table.Summary.Cell>
                  <Table.Summary.Cell />
                </Table.Summary.Row>
                <Table.Summary.Row>
                  <Table.Summary.Cell colSpan={6}><Text strong>总计</Text></Table.Summary.Cell>
                  <Table.Summary.Cell align="right"><Text strong style={{ color: '#52c41a' }}>¥ {totalCNY.toFixed(2)}</Text></Table.Summary.Cell>
                  <Table.Summary.Cell align="right"><div><Text strong style={{ color: '#52c41a' }}>$ {totalUSD.toFixed(2)}</Text></div><div><Text strong style={{ color: '#52c41a', fontSize: 12 }}>¥ {totalUsdCny.toFixed(2)}</Text></div></Table.Summary.Cell>
                  <Table.Summary.Cell align="right"><Text strong style={{ color: '#fa8c16' }}>¥ {grandTotal.toFixed(2)}</Text></Table.Summary.Cell>
                  <Table.Summary.Cell />
                </Table.Summary.Row>
              </>
            );
          }}
        />
              ),
            },
            {
              key: 'ad',
              label: '广告收益',
              children: (
                <Table columns={adColumns} dataSource={adBillData} rowKey="key"
                  pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
                />
              ),
            },
          ]}
        />
      </Card>

      {/* 修改提现账户 */}
      <Modal title="修改提现账户" open={bankVisible}
        onOk={async () => { try { await bankForm.validateFields(); message.success('提现账户已更新'); setBankVisible(false); } catch(e){} }}
        onCancel={() => setBankVisible(false)} okText="保存" cancelText="取消" destroyOnClose width={520}
      >
        <Form form={bankForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item name="accountName" label="账户名" rules={[{ required: true, message: '请输入账户名' }]}>
            <Input placeholder="请输入账户名" />
          </Form.Item>
          <Form.Item name="bankName" label="开户银行名称" rules={[{ required: true, message: '请输入开户银行名称' }]}>
            <Input placeholder="请输入开户银行名称" />
          </Form.Item>
          <Form.Item name="bankCode" label="开户银行行号" rules={[{ required: true, message: '请输入开户银行行号' }]}>
            <Input placeholder="请输入开户银行行号" />
          </Form.Item>
          <Form.Item name="accountNo" label="开户银行账号" rules={[{ required: true, message: '请输入开户银行账号' }]}>
            <Input placeholder="请输入开户银行账号" />
          </Form.Item>
        </Form>
      </Modal>

    </div>
  );
};

export default IncomeAccount;
